import { configureStore, Reducer } from '@reduxjs/toolkit';
import { FLUSH, PAUSE, PERSIST, persistReducer, persistStore, PURGE, REGISTER, REHYDRATE } from 'redux-persist';
import { PersistPartial } from 'redux-persist/lib/persistReducer';

import { rootReducer } from 'app/redux/reducer/root-reducer';
import { RootState } from 'app/redux/state/root-state';
import { StateService } from 'app/services/state-service';

import { rootPersistConfig } from './store-config';

const createStore = (preloadedState?: RootState & PersistPartial) => {
    const reducer: Reducer<RootState & PersistPartial> = configurePersistReducer();

    return configureStore({
        reducer,
        preloadedState,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: {
                    ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
                },
            }),
    });
};

const configurePersistReducer = (): Reducer<RootState & PersistPartial> =>
    persistReducer(rootPersistConfig, rootReducer);

export const store = createStore();

export const persistor = persistStore(store);

StateService.injectStore(store);
